import {config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class ServerBraillerRepairRequestApi {
    static getStudents(studentSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(studentSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(`${config.URL}students/patrons?${queryParameters}`,
                requestTypes.GET,
            )
        );
    }

    static getShippingLocations() {
        return sendRequest(
            requestOptions(`${config.URL}shipping-locations`,
                requestTypes.GET,
            )
        );
    }
}

export const braillerRepairRequestApi = config.environment.MODE === config.modes.SERVER ? ServerBraillerRepairRequestApi : ServerBraillerRepairRequestApi;
